import React, { useCallback } from "react";
import {
  UserLoggedInNavigatorParamList,
  UserLoggedInNavigatorScreenProps,
} from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { ProductSearch } from "../Products/ProductSearch";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { useNavigationHeaderOptions } from "../../common/navigationHeaderOptions";
import {
  Keyboard,
  NativeSyntheticEvent,
  TextInputChangeEventData,
} from "react-native";
import { useIntl } from "react-intl";
import { isInputEAN } from "../ProductExpireBatch/isInputEAN";
import {
  DEVICE_HAS_SCANNER,
  ScanToAddExpireDate,
} from "../Product/ScanToAddExpireDate";
import { AHText, Box } from "arkh";
import { isInputFromScan } from "./isInputFromScan";

type ParamList = {
  ProductExpireBatchCreateMain: UserLoggedInNavigatorParamList["ProductExpireBatchCreate"];
};
const Stack = createNativeStackNavigator<ParamList>();

const ProductExpireBatchCreateMain = ({
  navigation,
}: {
  navigation: UserLoggedInNavigatorScreenProps<"ProductExpireBatchCreate">["navigation"];
}) => {
  const prevText = React.useRef("");
  const [query, setQuery] = React.useState("");

  const onChange = useCallback(
    (e: NativeSyntheticEvent<TextInputChangeEventData>) => {
      if (
        isInputFromScan(e.nativeEvent.text, prevText.current) &&
        isInputEAN(e.nativeEvent.text.slice(prevText.current.length))
      ) {
        Keyboard.dismiss();
        const ean = e.nativeEvent.text.slice(prevText.current.length);
        prevText.current = "";
        setQuery("");
        navigation.navigateDeprecated("Product", {
          screen: "ProductMain",
          params: {
            ean,
            type: "ean",
            state: "expireDates-add",
          },
        });
      } else {
        prevText.current = e.nativeEvent.text;
        setQuery(e.nativeEvent.text);
      }
    },
    [navigation]
  );

  return (
    <ProductSearch
      query={query}
      isSearching
      autoFocus
      onPressProduct={(product) => {
        setQuery("");
        navigation.navigateDeprecated("Product", {
          screen: "ProductMain",
          params: {
            id: product.id,
            type: "id",
            state: "expireDates-add",
          },
        });
      }}
      onChange={onChange}
    />
  );
};

export const ProductExpireBatchCreate = withWebModal(
  (props: UserLoggedInNavigatorScreenProps<"ProductExpireBatchCreate">) => {
    const getOptions = useNavigationHeaderOptions();
    const intl = useIntl();
    const addExpireDateIntl = intl.formatMessage({
      defaultMessage: "Add Expire Date",
      description: "ProductExpireBatchCreate navigation header title",
    });
    return (
      <Stack.Navigator>
        <Stack.Screen
          name="ProductExpireBatchCreateMain"
          component={ProductExpireBatchCreateMain}
          options={getOptions({
            type: "CLOSE",
            headerTitle: DEVICE_HAS_SCANNER
              ? () => (
                  <Box
                    style={{ flexDirection: "column", alignItems: "center" }}
                  >
                    <ScanToAddExpireDate />
                    <AHText type="subtitle" spaceTop="xsmall">
                      {addExpireDateIntl}
                    </AHText>
                  </Box>
                )
              : addExpireDateIntl,
            onClose: () => props.navigation.goBack(),
          })}
        />
      </Stack.Navigator>
    );
  },
  true
);
